import { render, staticRenderFns } from "./FilterCarousel.vue?vue&type=template&id=27ba07c4&scoped=true&"
import script from "./FilterCarousel.vue?vue&type=script&lang=js&"
export * from "./FilterCarousel.vue?vue&type=script&lang=js&"
import style0 from "./FilterCarousel.vue?vue&type=style&index=0&id=27ba07c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ba07c4",
  null
  
)

export default component.exports